import { logger, } from "@bracket/ui";
import { formatUnits, } from "viem";
import { cst, } from "./cst";

export const formatWEI = ( v: string | bigint, decimals = 18, precision = 5, commas = false, ): string => {
	try {
		const value = typeof v === "string" ? BigInt(v.split(".")[0]) : v;
		const result = Number(formatUnits(value, decimals)).toFixed(precision);
		return commas ? cst(result, precision) : result;
	}
	catch(error) {
		logger.warn(`@bracket/platform/formatters/WEI:formatWEI - error formatting WEI value of type ${typeof v} :: ${error instanceof Error ? error.message : error}`);
		return "N/A";
	}
};
